/**
 * FaviconMark — mêmes pixels exacts que public/favicon.svg (utilisé dans l'onglet navigateur).
 * À utiliser partout où on veut un "logo monquiz reconnaissable" inline (menu user, breadcrumb, etc.).
 */
export function FaviconMark({ size = 16, className = '' }) {
    const gradId = `favicon-g-${size}`;
    return (
        <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true" className={className}>
            <defs>
                <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#7c3aed" />
                    <stop offset="100%" stopColor="#2563eb" />
                </linearGradient>
            </defs>
            <rect width="32" height="32" rx="7" fill={`url(#${gradId})`} />
            <polyline points="6,16 11,21 19,10" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            <polyline points="12,19 17,24 26,13" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function BrandMark({ size = 18 }) {
    return (
        <svg viewBox="0 0 30 56" width={Math.round(size * 30 / 56)} height={size} aria-hidden="true">
            <defs>
                <linearGradient id="bm-lg" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7c3aed" />
                    <stop offset="100%" stopColor="#2563eb" />
                </linearGradient>
            </defs>
            <rect x="0" y="0" width="5" height="56" rx="2.5" fill="url(#bm-lg)" />
            <g transform="translate(14,8)">
                <rect x="0" y="0" width="13" height="13" rx="2.5" fill="none" stroke="#7c3aed" strokeWidth="1.8" />
                <path d="M3 6.5 L5.5 9.5 L10.5 3" stroke="#7c3aed" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="0" y="18" width="13" height="13" rx="2.5" fill="none" stroke="#2563eb" strokeWidth="1.8" />
                <path d="M3 24.5 L5.5 27.5 L10.5 21" stroke="#2563eb" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
}

export default function BrandLogo({ width = 188, className = '', hideTagline = false, monColor = null }) {
    // viewBox: 290x90 full, 220x62 compact (hideTagline crops to content area).
    // 290 (au lieu de 340) = on resserre le vide à droite : le contenu (logo + tagline)
    // s'arrête vers ~270, on garde ~20u de marge pour ne pas rogner la tagline.
    const vbWidth = hideTagline ? 220 : 290;
    const vbHeight = hideTagline ? 62 : 90;
    const isFluid = typeof width === 'string'; // 'auto', '80%', etc.
    const height = isFluid ? 'auto' : Math.round(width * vbHeight / vbWidth);

    return (
        <svg
            viewBox={`0 0 ${vbWidth} ${vbHeight}`}
            width={isFluid ? (width === 'auto' ? '100%' : width) : width}
            height={height}
            className={`brand-logo ${className}`}
            aria-label="MonQuiz.fr — ta reussite commence ici"
            role="img"
        >
            <defs>
                <linearGradient id="brand-lg" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7c3aed" />
                    <stop offset="100%" stopColor="#2563eb" />
                </linearGradient>
            </defs>
            <rect x="0" y="8" width={vbWidth} height="56" rx="8" fill="transparent" />
            <rect x="0" y="8" width="5" height="56" rx="2.5" fill="url(#brand-lg)" />
            <g transform="translate(16,20)">
                <rect x="0" y="0" width="13" height="13" rx="2.5" fill="none" stroke="#7c3aed" strokeWidth="1.8" />
                <path d="M3 6.5 L5.5 9.5 L10.5 3" stroke="#7c3aed" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="0" y="18" width="13" height="13" rx="2.5" fill="none" stroke="#2563eb" strokeWidth="1.8" />
                <path d="M3 24.5 L5.5 27.5 L10.5 21" stroke="#2563eb" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <text x="42" y="48" fontFamily="Impact, 'Arial Black', sans-serif" fontSize="38" letterSpacing="0.5">
                <tspan fill={monColor || 'var(--text, white)'}>Mon</tspan>
                <tspan fill="#a78bfa">Quiz</tspan>
                <tspan fill="#60a5fa" fontSize="24">.fr</tspan>
            </text>
            {!hideTagline && (
                <text x="135" y="80" textAnchor="middle" fontFamily="'Fira Code', 'Courier New', monospace" fontSize="15" fill="var(--text-muted, #64748b)" letterSpacing="1.5">
                    &#9658; ta reussite commence ici
                </text>
            )}
        </svg>
    );
}
